import {cdnImage, cdnUrl} from '@/util/cdnImage';
const featureprologo1 = cdnImage('banner-bottom/featureprologo1.webp');
const featureprologo2 = cdnImage('banner-bottom/fox-news-logo.webp');
const featureprologo3 = cdnImage('banner-bottom/featureprologo3.webp');
const featureprologo4 = cdnImage('banner-bottom/featureprologo4.webp');
const featureprologo5 = cdnImage('banner-bottom/nbc.webp');
const featureprologo6 = cdnImage('banner-bottom/Techinasia.webp');
export const bannerBottomPortfolio = [
    {src: featureprologo1, alt: 'Abc News'},
    {src: featureprologo2, alt: 'fox News'},
    {src: featureprologo3, alt: 'Appindex'},
    {src: featureprologo4, alt: 'Bloomberg Business'},
    {src: featureprologo5, alt: 'NBC News'},
    {src: featureprologo6, alt: 'TECHINASIA'},
    {src: featureprologo1, alt: 'Abc News'},
    {src: featureprologo2, alt: 'fox News'},
    {src: featureprologo3, alt: 'Appindex'},
    {src: featureprologo4, alt: 'Bloomberg Business'},
    {src: featureprologo5, alt: 'NBC News'},
    {src: featureprologo6, alt: 'TECHINASIA'}
];
const cimetLogo = cdnImage('Portfolio-images/Cimet-logo.webp');
const wellpopLogo = cdnImage('Portfolio-images/Wellpop-logo.webp');
const ifincaLogo = cdnImage('Portfolio-images/ifinca-logo.webp');
const integraLogo = cdnImage('Portfolio-images/Integra-logo.webp');
const ndaxLogo = cdnImage('Portfolio-images/Ndax-logo.webp');
const everledgerLogo = cdnImage('Portfolio-images/Everledger-logo.webp');
const friendspireLogo = cdnImage('Portfolio-images/Friendspire-logo.webp');
const lummidLogo = cdnImage('Portfolio-images/Lummid-logo.webp');
const uniqueSchoolLogo = cdnImage('Portfolio-images/Unique-school-logo.webp');
const talentQuest = cdnImage('Portfolio-images/Talent-quest.webp');
const titletech = cdnImage('Portfolio-images/Titletech 1.webp');
const cimet = cdnImage('Portfolio-images/Cimet.webp');
const wellpop = cdnImage('Portfolio-images/Wellpop-1.webp');
const ifinca = cdnImage('Portfolio-images/ifinica.webp');
const integra = cdnImage('Portfolio-images/Integra.webp');
const ndax = cdnImage('Portfolio-images/Ndax.webp');
const friendspire = cdnImage('Portfolio-images/Friendspire.webp');
const lummid = cdnImage('Portfolio-images/Lumid 1.webp');
const uniqueSchool = cdnImage('Portfolio-images/Unique-school.webp');
const everledger = cdnImage('Portfolio-images/Everledger 1.webp');
const p2b = cdnImage('Portfolio-images/P2b.webp');
const aithentic = cdnImage('Portfolio-images/Aithentic.webp');
const aithenticLogo = cdnImage('Portfolio-images/aithentic-logo.webp');
const dph = cdnImage('Portfolio-images/DPH.webp');
const prc = cdnImage('Portfolio-images/PRC-Coin.webp');
const prcLogo = cdnImage('Portfolio-images/PRC-Coin-logo.webp');
const nordicStrong = cdnImage('Portfolio-images/Nordic-strong.webp');
const nordicStrongLogo = cdnImage('Portfolio-images/Nordicstrong-logo.webp');
const openKey = cdnImage('Portfolio-images/open-key.webp');
const openKeyLogo = cdnImage('Portfolio-images/openkey-logo.webp');
const kfcDeliveryStoreApp = cdnImage('Portfolio-images/KFC-delivery-app.webp');
const kfcLogo = cdnImage('Portfolio-images/KFC-logo.webp');
const hdfcLife = cdnImage('Portfolio-images/Hdfc-life.webp');
const hdfcLifeLogo = cdnImage('Portfolio-images/hdfclife-logo.webp');
const getvetImage = cdnImage('GuardianVets-Case-Study/guardianvet-card-img.webp');
const nijcBanner = cdnImage('nijc-case-study/nijc-banner.webp');
// Curated subset of the portfolio for the home page's tabbed case-study section.
// `tabTitle`/`tabSubtitle` are the left-rail labels; stats mirror `latestPortfolioData`.
export const homeCaseStudyTabsData = [
    {
        tabTitle: 'AI Software',
        tabSubtitle: 'For Inventory Management',
        heading: 'AI-Powered Automation Platform for the Container Inventory',
        desc: 'Automated inventory and quoting across a multi-party container network, replacing spreadsheet handoffs with a single live view of stock and pricing.',
        logoSrc: lummidLogo,
        logoAlt: 'Lummid logo',
        imgSrc: cdnUrl('home-page-updated-assets/lumid-1.webp'),
        imgAlt: 'Lummid container inventory automation dashboard',
        imgAspectRatio: '1155 / 1274',
        stats: [
            {header: '35%', body: 'Faster quote turnaround'},
            {header: '50%', body: 'Lower manual workload'}
        ],
        redirect: '/case-study/lummid'
    },
    {
        tabTitle: 'Crypto Trading Suite',
        tabSubtitle: 'for Fintech',
        heading: 'An Enterprise-Ready Crypto Suite for Secure Trading & Asset Management',
        desc: 'A full exchange ecosystem — trading engine, custody, and compliance tooling — engineered to stay fast and auditable at national scale.',
        logoSrc: ndaxLogo,
        logoAlt: 'NDAX logo',
        imgSrc: cdnUrl('home-page-updated-assets/ndax-1.webp'),
        imgAlt: 'NDAX crypto trading platform interface',
        imgAspectRatio: '1155 / 1274',
        stats: [
            {header: '$12B', body: 'In cumulative trading volume'},
            {header: '2nd Largest', body: "Canada's crypto exchange by volume"}
        ],
        redirect: '/case-study/ndax-ecosystem'
    },
    {
        tabTitle: 'SaaS Software',
        tabSubtitle: 'For Utility Comparison',
        heading: 'An Enterprise Energy Comparison Platform Built for Growth',
        desc: 'A retail comparison platform that helps shoppers weigh options side by side, turning research time into confident, faster purchase decisions.',
        logoSrc: cimetLogo,
        logoAlt: 'Cimet logo',
        imgSrc: cdnUrl('home-page-updated-assets/cimet-1.webp'),
        imgAlt: 'Cimet consumer comparison platform interface',
        imgAspectRatio: '1155 / 1272',
        stats: [
            {header: '$26.6M', body: 'Strategic funding secured'},
            {header: '$11M', body: 'Revenue achieved'}
        ],
        redirect: '/case-study/cimet'
    },
    {
        tabTitle: 'Healthcare Software',
        tabSubtitle: 'For Care Coordination',
        heading: 'An Enterprise Care Coordination Platform for Healthcare Providers',
        desc: 'A unified platform connecting care teams and patients, bringing scheduling, records, and communication for connected healthcare into one place.',
        logoSrc: wellpopLogo,
        logoAlt: 'Wellpop logo',
        imgSrc: cdnUrl('home-page-updated-assets/Wellpop-1.webp'),
        imgAlt: 'Wellpop connected healthcare platform interface',
        imgAspectRatio: '1155 / 1274',
        stats: [
            {header: '80+', body: 'Professionals delivering care'},
            {header: '$5M+', body: 'Revenue generated'}
        ],
        redirect: '/case-study/wellpop'
    },
    {
        tabTitle: 'Blockchain Software',
        tabSubtitle: 'For Supply Chain',
        heading: 'A Mobile-First Blockchain-Based Solution For Coffee Supply Chain',
        desc: 'An innovative solution that optimizes and simplifies the coffee supply chain, ensuring transparency, efficiency, and sustainability from farm to cup.',
        logoSrc: ifincaLogo,
        logoAlt: 'iFinca logo',
        imgSrc: cdnUrl('home-page-updated-assets/ifinca-1.webp'),
        imgAlt: 'iFinca mobile app showing coffee supply chain participants',
        imgAspectRatio: '1155 / 1274',
        stats: [
            {header: '$2M', body: 'Funding Received'},
            {header: '18K+', body: 'Producers & Co-Ops'}
        ],
        redirect: '/case-study/ifinca'
    },
    {
        tabTitle: 'AI Chatbot',
        tabSubtitle: 'for Legal Services',
        heading: 'Enterprise AI Chatbot & Legal Automation Platform for Immigration Case Management',
        desc: 'An AI assistant that handles first-line immigration queries end to end, freeing legal teams to spend their time on the cases that need a lawyer.',
        logoSrc: '',
        logoAlt: '',
        imgSrc: cdnUrl('home-page-updated-assets/nijc-1.webp'),
        imgAlt: 'AI legal automation platform handling immigration case queries',
        imgAspectRatio: '1155 / 1274',
        stats: [
            {header: '40%', body: 'Reduction in consultation handling time'},
            {header: '80%+', body: 'Initial queries resolved automatically'}
        ],
        redirect: '/case-study/ai-legal-chatbot-immigration-automation'
    }
];

export const latestPortfolioData = [
    {
        heading: 'AI-Powered Legal Automation Platform for Immigration Services',
        buttonText: 'View Project Details',
        imgSrc: nijcBanner,
        keyPoint: [
            {header: '40%', body: 'Reduction in Consultation Handling Time'},
            {header: '80%+', body: 'Initial Queries Resolved Automatically'}
        ],
        redirect: 'case-study/ai-legal-chatbot-immigration-automation',
        logoSrc: '',
        type: 'Healthcare',
        service: ['Artificial Intelligence']
    },
    {
        heading: 'AI-Powered Call Management Solution for a Veterinary Telehealth Platform',
        buttonText: 'View Project Details',
        imgSrc: getvetImage,
        keyPoint: [
            {header: 'Instant', body: ' First-Ring AI Response'},
            {header: '100%', body: ' Inbound Calls Successfully Managed'}
        ],
        redirect: '/case-study/ai-veterinary-telehealth-platform',
        logoSrc: '',
        type: 'Healthcare',
        service: ['Artificial Intelligence']
    },
    {
        heading: 'PRC – A Blockchain-Based Exchange and ICO Platform for Real Estate Finance',
        buttonText: 'View Project Details',
        imgSrc: prc,
        keyPoint: [
            {header: '12K+', body: 'Registered Investors'},
            {header: '3-in-1 Platform', body: ' ICO + Exchange + Payment Ecosystem'}
        ],
        logoSrc: prcLogo,
        redirect: '/case-study/prc',
        type: 'Real Estate',
        service: ['Blockchain Development']
    },
    {
        heading: 'An Enterprise Crypto Suite for Secure Trading',
        buttonText: 'View Project Details',
        imgSrc: ndax,
        keyPoint: [
            {header: '$12B', body: 'in cumulative trading volume'},
            {header: '2nd Largest', body: "Canada's crypto exchange by volume"}
        ],
        redirect: '/case-study/ndax-ecosystem',
        logoSrc: ndaxLogo,
        type: 'FinTech',
        service: ['Cryptocurrency Development']
    },
    {
        heading: 'A Deep Learning Solution for Smarter Candidate Search ',
        buttonText: 'View Project Details',
        imgSrc: talentQuest,
        keyPoint: [
            {header: '750,000', body: 'candidate matches facilitated'},
            {header: '30%', body: 'Increase in recruitment efficiency'}
        ],
        redirect: '/case-study/talentquest',
        type: 'Recruitment',
        service: ['Artificial Intelligence']
    },
    {
        heading: 'An AI-Powered Solution for Title Insurance Providers',
        buttonText: 'View Project Details',
        imgSrc: titletech,
        keyPoint: [
            {header: '100,000', body: 'Processed land deed documents'},
            {header: '40%', body: 'Increase in extraction accuracy'}
        ],
        redirect: '/case-study/titletech',
        type: 'FinTech',
        service: ['Artificial Intelligence']
    },
    {
        heading: 'A Comparison Platform Designed for Confident Consumer Decisions',
        buttonText: 'View Project Details',
        imgSrc: cimet,
        keyPoint: [
            {header: '$26.6M', body: 'Strategic funding secured '},
            {header: '$11M', body: 'Revenue achieved'}
        ],
        redirect: '/case-study/cimet',
        logoSrc: cimetLogo,
        type: 'Retail',
        service: ['Web Development']
    },
    {
        heading: 'An Unified Digital Platform Advancing Connected Healthcare',
        buttonText: 'View Project Details',
        imgSrc: wellpop,
        keyPoint: [
            {header: '80+', body: 'Professionals delivering care'},
            {header: '$5M+', body: 'Revenue generated '}
        ],
        redirect: '/case-study/wellpop',
        logoSrc: wellpopLogo,
        type: 'Healthcare',
        service: ['Web Development', 'Mobile Development']
    },
    {
        heading: 'A Blockchain Based Solution For Coffee Supply Chain',
        buttonText: 'View Project Details',
        imgSrc: ifinca,
        keyPoint: [
            {header: '$2M', body: 'Funding Received'},
            {header: '18K+', body: 'Producers & Co-Ops'}
        ],
        redirect: '/case-study/ifinca',
        logoSrc: ifincaLogo,
        type: 'AgriTech',
        service: ['Web Development', 'Blockchain Development', 'Mobile Development']
    },
    {
        heading: 'A Blockchain Based Digital Signature Platform',
        buttonText: 'View Project Details',
        imgSrc: integra,
        keyPoint: [
            {header: '$3M', body: 'Funding Received'},
            {header: '300+', body: 'Law Firms'}
        ],
        redirect: '/case-study/integraledger',
        logoSrc: integraLogo,
        type: 'LegalTech',
        service: ['Web Development', 'Blockchain Development']
    },
    {
        heading: 'AI-Powered Inventory Automation Platform for Container Supply Networks',
        buttonText: 'View Project Details',
        imgSrc: lummid,
        keyPoint: [
            {header: '35%', body: 'Faster quote turnaround'},
            {header: ' 50%', body: 'Lower manual workload'}
        ],
        redirect: '/case-study/lummid',
        logoSrc: lummidLogo,
        type: 'Supply Chain & Logistics',
        service: ['Artificial Intelligence']
    },
    {
        heading: 'OpenKey – A Mobile Key Platform for Contactless Hotel Access',
        imgSrc: openKey,
        keyPoint: [
            {header: '50+', body: 'PMS integrations across the hospitality ecosystem'},
            {header: '2026', body: 'acquired by Canary Technologies'}
        ],
        logoSrc: openKeyLogo,
        // No case-study page yet — keyed by id so the card renders unlinked (see KFC above).
        id: 'openkey',
        type: 'Hospitality',
        service: ['Enterprise SaaS']
    },
    {
        heading: 'A Supply Chain Efficiency Platform for Oil & Gas Networks',
        buttonText: 'View Project Details',
        imgSrc: p2b,
        keyPoint: [
            {header: '$15M+', body: 'Annual SaaS License Value'},
            {header: '30%', body: 'Reduction in Procurement Cycle Time'}
        ],
        redirect: '/case-study/p2b',
        type: 'Energy & Natural Resources',
        service: ['Enterprise SaaS']
    },
    {
        heading: 'Nordic Strong – A Connected Fitness Platform for Nordic-Inspired Training',
        imgSrc: nordicStrong,
        keyPoint: [
            {header: '1st U.S. Studio', body: 'opened in New York City in 2025'},
            {header: '3 Training Formats', body: 'delivered through patented indoor fitness equipment'}
        ],
        logoSrc: nordicStrongLogo,
        // No case-study page yet — keyed by id so the card renders unlinked (see KFC above).
        id: 'nordic-strong',
        type: 'Fitness & Wellness',
        service: ['Enterprise SaaS']
    },
    {
        heading: 'HDFC Life Insta – An AI-Enabled Insurance Platform for Digital Policy Sales',
        imgSrc: hdfcLife,
        keyPoint: [
            {header: '15% Growth', body: 'in policies sold over nine months'},
            {header: '24% Increase', body: 'in retail new business premiums'}
        ],
        logoSrc: hdfcLifeLogo,
        // No case-study page yet — keyed by id so the card renders unlinked (see KFC above).
        id: 'hdfc-life-insta',
        type: 'Insurance & InsurTech',
        service: ['Enterprise SaaS']
    },
    {
        heading: 'A Smart School Management Platform Elevating Legacy Education Domains',
        buttonText: 'View Project Details',
        imgSrc: uniqueSchool,
        keyPoint: [
            {header: '140+', body: 'renowned schools'},
            {header: '100,000+', body: 'user using this platform'}
        ],
        redirect: '/case-study/unique-school',
        logoSrc: uniqueSchoolLogo,
        type: 'Edtech',
        service: ['Web Development']
    },
    {
        heading: 'A Blockchain-Based Diamond Traceability Solution',
        buttonText: 'View Project Details',
        imgSrc: everledger,
        keyPoint: [
            {header: '$20M', body: 'funding received'},
            {header: ' 50', body: 'Top companies worldwide'}
        ],
        redirect: '/case-study/everledger',
        logoSrc: everledgerLogo,
        type: 'Supply Chain & Logistics',
        service: ['Blockchain Development']
    },
    {
        heading: 'A Personalized Entertainment Recommendation Solution',
        buttonText: 'View Project Details',
        imgSrc: friendspire,
        keyPoint: [
            {header: '$300K', body: 'seed capital achieved'},
            {header: '10,000', body: 'user sign-ups post‑launch'}
        ],
        redirect: '/case-study/friendspire',
        logoSrc: friendspireLogo,
        type: 'Media & Entertainment',
        service: ['Mobile Development']
    },
    {
        heading: 'AI-Enabled IT Asset Management Solution for Global Enterprises',
        buttonText: 'View Project Details',
        imgSrc: aithentic,
        keyPoint: [
            {header: '10,000+ ', body: 'Assets Managed Per Deployment'},
            {header: '85%', body: 'Improvement in Asset Tracking Accuracy'}
        ],
        redirect: '/case-study/aithentic',
        type: 'Enterprise Technology Solutions',
        logoSrc: aithenticLogo,
        service: ['Artificial Intelligence']
    },
    {
        heading: 'KFC Delivery Store App – A Mobile Ordering and POS Platform for QSR Delivery Operations',
        imgSrc: kfcDeliveryStoreApp,
        keyPoint: [
            {header: '960+', body: 'KFC restaurants across South Africa'},
            {header: '#1 Fast-Food Chain', body: 'in South Africa by outlet count'}
        ],
        logoSrc: kfcLogo,
        // No case-study page exists for this one yet, so it carries an `id` instead of a
        // `redirect`: the card renders unlinked (PortfolioCard falls back to the enquiry form)
        // and `pickPortfolio` still selects it by this id.
        id: 'kfc-delivery-store-app',
        type: 'Food & Restaurant',
        service: ['Enterprise SaaS']
    },
    {
        heading: 'Transforming Healthcare Delivery Through Outcome-Based Blockchain Infrastructure ',
        buttonText: 'View Project Details',
        imgSrc: dph,
        keyPoint: [
            {header: '25K+', body: 'Patient Records Managed'},
            {header: '50+', body: ' Healthcare Stakeholders Integrated'}
        ],
        redirect: '/case-study/blockchain-in-healthcare',
        type: 'Healthcare',
        service: ['Blockchain Development']
    }
];

/**
 * Pick specific case studies by their `redirect` path, in the order given.
 *
 * Use this in a page's `getStaticProps` when the page needs a hand-picked,
 * fixed set of studies — it ships only those items in the page payload instead
 * of the whole array, and the order you pass is the order they render in.
 * Pair it with `showFilters={false}` on <LatestPortfolio>.
 *
 *   const portfolio = pickPortfolio(['/case-study/prc', '/case-study/ndax-ecosystem']);
 *
 * An unmatched path throws rather than rendering one card fewer, so a typo or a
 * renamed slug fails the build instead of silently shrinking the section.
 */
export const pickPortfolio = (redirects: string[]) => {
    const normalize = (path: string) => `/${path.replace(/^\//, '')}`;
    // Studies with no page yet have no `redirect`, so they are keyed by `id` instead.
    const keyOf = (item: {redirect?: string; id?: string}): string => item.redirect ?? item.id ?? '';
    const byRedirect = new Map(latestPortfolioData.map((item) => [normalize(keyOf(item)), item]));

    return redirects.map((path) => {
        const item = byRedirect.get(normalize(path));
        if (!item) throw new Error(`pickPortfolio: no case study found for "${path}"`);
        return item;
    });
};

// ─── Curated per-topic sets ───────────────────────────────────────────────────
// Fixed, hand-picked lists that replace the old client-side `defaultFilters` on
// service pages. Same studies the filters resolved to, but chosen at build time,
// so the page ships only these items and renders them without a filter UI.
// Add or reorder a study here and every page using that set follows.

export const aiPortfolio = pickPortfolio([
    '/case-study/ai-legal-chatbot-immigration-automation',
    '/case-study/ai-veterinary-telehealth-platform',
    '/case-study/talentquest',
    '/case-study/titletech',
    '/case-study/lummid',
    '/case-study/aithentic'
]);

export const blockchainPortfolio = pickPortfolio([
    '/case-study/prc',
    '/case-study/ndax-ecosystem',
    '/case-study/ifinca',
    '/case-study/integraledger',
    '/case-study/everledger',
    '/case-study/blockchain-in-healthcare'
]);

export const saasPortfolio = pickPortfolio(['openkey', '/case-study/p2b', 'nordic-strong', 'hdfc-life-insta', 'kfc-delivery-store-app']);
